import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: ${Spacing.S24};
`

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 270px;
`
